import utils from "@SyoLab/utils"
import { CertifiedDatabase, } from "@icons/appFabric/icons"
//const defaultApp = () => import(/* webpackChunkName: "DefaultApp" */"./Default.vue")
import component from "./Subscriptions.vue"
const appName = 'subscriptions'
const basePath = "/subscriptions"
export default {
   name: appName,
   auth: true, //auth: if authenticated must have app in userApps
   menuShow: false, //menuShow overrides everything
   menuPosition: 5, //sorting menu position of app
   component: component,
   // appConfig from base -> available in Component.appConfig
   // appConfig: {
   //    foo: 'foo'
   // },
   // routes are used to match all menuItem routes
   // the are referenced to the app
   routes: [
      {
         name: "subscriptions",
         path: "/subscriptions*"
      }
   ],
   menu: [
      {
         //"appName": appName, -> not needed appName is referenced on import
         "text": "Hosting & Abos",
         "icon": CertifiedDatabase,
         "class": "defClass root",
         "route": '/subscriptions', //route path
         "action": undefined, //action emitted to app
         "enabled": true, // enabled / disable menu item (can be used as function with appConfig)
         // status
         "active": false, // is active menu item
         "show": true, // show / hide, toggles visibility on click

      }
   ]
}